import ko from "knockout";

export class PopupModel {
    title: KnockoutObservable<string>;
    content: KnockoutObservable<string>;
    buttonText: KnockoutObservable<string>;
    clickHandler: KnockoutObservable<(() => void)>;

    constructor(title: string, content: string, buttonText: string) {
        this.title = ko.observable<string>(title);
        this.content = ko.observable<string>(content);
        this.buttonText = ko.observable<string>(buttonText);
        this.clickHandler = ko.observable<(() => void)>();
    }
    
    click() {
        this.clickHandler()(); 
    }
}
